module.exports = function() {
  return new Worker(__webpack_public_path__ + "d82618a644586cf8e11d.worker.js");
};